export default {
  locales: ["en-US"],
  messages: {
    // post: {
    //     meta: 'Posted {ago}, {num, plural, one{# comment} other{# comments}}'
    // },
    // time : {

    // },
    webinar: {
      fullScreen: "Full screen",
      useCoursio: 'Use Coursio account for webinar modules',
      missedSettings: 'Please setup you webinar settings or use Coursio account',
      domain: 'Domain',
      description: 'Description',
      roomName: 'Room name',
      enter: 'Enter',
      isWebinar: 'Please, choose module type:',
    },
    user: {
      updated: "User roles updated",
    },
    login: {
      success: "Welcome!",
      loggedOut: "See you again, soon.",
      redirectIncoming:
        "You are already logged in, you will be redirected to the dashboard.",
      toDashboard: "Login to your dashboard",
    },
    coursio: {
      welcome: "Welcome to Coursio",
    },
    dashboard: {
      remove: "Are you sure?",
      removed: "Course has been removed",
      filterAll: "All",
      filterCompleted: "Completed",
      filterNotCompleted: "Not completed",
      filterExpiresSoon: "Expires soon",
      filterGood: "Good",
      filterNew: "New",
      filterPaid: "Paid",
      filterRegistered: "Registered",
      filterRefunded: "Refunded",
      filterCancelled: "Cancelled",
      filterError: "Error",
      filterOwn: "Own Courses",
      filterOthers: "Invited Courses",
      sortLastVisit: "Last Visited",
      sortCreated: "Last Created",
      filterAndSort: "Choose Filtering and Sorting",
      filter: "Choose Filtering",
      filterTitle: "Filter",
      sortTitle: "Sort By",
    },
    ozitor: {
      url: "URL",
      openInNewTab: "Open in new tab",
      createLink: "Create link",
      more: "More",
      less: "Less",
    },
    bug: {
      report: "Support",
      reportTitle: "Send request",
      describe:
        "If you have course related questions please contact course creator. For technical issues please describe it here.",
      reported: "Your request has been sent.",
      reportFailed: "Request report has failed.",
    },
    course: {
      properties: "Properties",
      category: "Category",
      nameTooLong: "Course name can be maximum of 50 characters.",
      nameNotEmpty: "Course name cannot be empty",
      buy: "Buy course",
      Courses: "Courses",
      access: "Course Access",
      remove: 'Remove course "{course}?',
      removed: "Course has been removed",
      revokeAccess: "Revoke access",
      show: "Show course",
      noSelected: "No course selected",
      choose: "Choose courses",
      setAccess: "Set course access",
      lastViewedPage: "Last page visited",
      whatIs: "What is an online course?",
      studentsInvited: "Students have been invited to course.",
      groupsInvited: "Groups have been invited to course.",
      goto: "Goto course",
      new: "Course name",
      add: "Add course",
      tableOfContents: "Table of Contents",
      access: "Access Until: ",
      dateSaved: "Access date has been saved",
      forever: "Forever",
    },
    group: {
      Groups: "Groups",
      remove: "Remove group?",
      add: "Add Group",
      removed: "Group has been removed.",
      create: "New Group",
      name: "Group name",
      expunge: "Also expunge all privileges granted through this group.",
      doesNotExist: "This group does not exist.",
      noSelected: "No group selected",
      revokeAccess: 'Revoke access for group "{group}" from course "{course}"?',
      revokedAccess: "Access has been revoked for this group.",
      show: "Show group",
      choose: "Choose groups",
      removeCourse: "Remove course",
      removeCourseConfirm:
        "Are you sure you want to remove this course from the group?",
      removeStudent: "Remove student",
      removeStudentConfirm:
        "Are you sure you want to remove this student from the group?",
      removeInvite: "Remove invite",
      removeInviteConfirm:
        "Are you sure you want to remove this invite from the group?",
      removedInvite: "Invitation has been removed",
      coursesAdded: "Course(s) added",
      courseRemoved: "Course removed",
      editing: "Editing Group Name",
      send: "Send to me",
    },
    students: {
      students: "Students",
      invitations: "Invitations",
    },
    student: {
      active: "Active {ago}.",
      neverActive: "Student has never been active.",
      Students: "Students",
      delete: "Remove student",
      Invited: "Invited",
      Registered: "Registered",
      remove: 'Remove student "{student}"?',
      removed: "Student has been removed.",
      removeFromCourse: "Remove from course",
      revokeAccess:
        'Revoke access for student "{student}" from course "{course}"?',
      revokedAccess: "Access has been revoked.",
      show: "Show student",
      removeFromGroupShort: "Remove from group?",
      removeFromGroup: 'Remove student "{student} from group "{group}" ?',
      removedFromGroup: "Student has been removed from group.",
      addedToGroup: "Student has been added to group.",
      multiAddedToGroup: "Students have been added to group.",
      choose: "Choose students",
      addToCourseShort: "Add to courses",
      add: "Add student",
      inviteNew: "Invite new students",
      exportDone: "Student export was sent to your email.",
      exportStatisticDone: "Statistic export was sent to your email.",
      expel: "Delete student account",
      expelConfirm:
        'Attention! Are you sure you want to delete the student "{student}"? After this action "{student}" will be deleted for ever from all courses and groups',
      expelDone: "Student has been removed from all your courses and groups",
      noSelected: "No student selected",
    },
    menu: {
      Quiz: "Quiz",
      Notes: "Notes",
      Tasks: "Tasks",
      Stripe: "Stripe",
      Dashboard: "Dashboard",
      StudentManagement: "Student management",
      Notification: "Notification",
      Settings: "Settings",
      Incarnate: "Incarnate",
      Invite: "Invite",
      Wakeup: "Wake up",
      Logout: "Log out",
      Courses: "Courses",
      ECommerce: "E-Commerce",
      Store: "Store",
      saleStats: "Statistics",
      Transactions: "Transactions",
      Discounts: "Discounts",
      Bundles: "Bundles",
      mediaLibrary: "Media library",
      Back: "Back",
      Help: "Help",
      SubAccounts: "Sub-Accounts",
      TaC: "Terms and conditions",
    },
    invite: {
      supplyEmails: "Please enter at least one email",
      studentInvitedToCourse: "Student has been invited to course.",
      groupInvitedToCourse: "Group has been invited to course.",
      chooseCourses: "Choose course(s)",
      chooseGroups: "Choose group(s)",
      chooseStudents: "Choose student(s)",
      selectedCourses: "Selected courses",
      selectedGroups: "Selected groups",
      selectedStudents: "Selected students",
      existingStudents: "Existing Students",
      newStudents: "New Students",
      groups: "Groups",
      summary: "Summary",
      summaryExplanation:
        "Below is a summary of your choices for your convenience",
      accessTime: "Access time",
      willHaveAccessTill: "Students will have access to these courses till : ",
      willHaveAccessFor: "Students will have access to these courses for : ",
      chooseCourseExplanation:
        "Please choose one or more courses to invite students to",
      chooseAccessTime: "Choose access duration",
      chooseAccessTimeExplanation:
        "Please specify how long the students will have access to the course(s) after accessing the course : ",
      chooseEndDate: "Choose end date",
      chooseEndDateExplanation:
        "Please specify till which date this group will have access to the course(s) : ",
      chooseStudentsOrGroups: "Do you want to invite Students or Groups?",
      Unlimited: "Unlimited",
      oneMonth: "One Month",
      threeMonths: "Three Months",
      sixMonths: "Six Months",
      oneYear: "One Year",
      oneAndHalfYear: "Eighteen Months",
      twoYears: "Two Years",
      accessMonths: "{months} month(s)",
      enterEmail: "Enter email addresses",
      confirmSend: "Confirm and send",
      sendInvite: "Send invite",
      sentOut: "Invites have been sent out.",
      Invites: "Invites",
      foundEmails: "Found email addresses",
      createTags: "Tags",
      addToGroup: "Add to a group",
      createGroupExplanation:
        "Type in the name of a new group to be created for these students and press enter",
      success: "You have successfully invited students, would you like to:",
      inviteMore: "Invite More?",
    },
    invitation: {
      expired:
        "This invitation has expired and thus cannot be accepted anymore.",
      used:
        "This invitation has already been used and thus cannot be accepted anymore.",
      accepted: "Invitation accepted",
      acceptText:
        "Please finalize your invitation by pressing the button below. This invitation was sent to {email}",
      redirectIncoming: "You will be redirected to the dashboard.",
      redirectLoginPage: "You will be redirected to the login page.",
      remove: "Remove",
      revokeAccess: "Revoke access?",
      resend: "Resend invitation",
      resendAll: "Resend invitations to All",
      prolongAccess: "Resend invitation for the course?",
      resent: "Email with an invitation link was resent.",
      allResent: "Email with an invitation link was resent to all.",
      accept: "Accept invitation",

      chosen: "Resend invitation to chosen email(s)",
      notChosen: "No email was chosen to send an invitation to",
      admin: "Admin rights",
    },
    item: {
      read: "Mark as read",
    },
    bundle: {
      updated: "Bundle updated.",
      new: "New bundle",
      remove: "Remove bundle",
      removed: "Bundle removed.",
      removeCourse: "Remove course",
      removedCourse: "Course removed from bundle.",
      removeCourseConfirm: "Are you sure you want to remove this course?",
      removeBundle: "Are you sure you want to remove bundle {bundle}?",
      name: "Name of the bundle",
      in1: "{courseCount} in 1",
      choose: "Choose bundle",
    },

    discount: {
      new: "New discount",
      remove: "Remove discount",
      removed: "Discount removed.",
      removeDiscount: "Are you sure you want to remove discount «{discount}»?",
      activate: "Activate code",
      code: "Discount code",
      enterCode: "Enter code (max 30 characters)",
      codeRestriction: "Code cannot be longer than 30 characters",
      amount: "Amount",
      active: "Active",
      limitedUse: "Limited use",
      Start: "Start",
      End: "End",
      Activation: "Activation",
      Manual: "Manual",
      Date: "Date",
      All: "All",
      Selected: "Selected",
      amountMustBeNumeric: "Amount must be numeric.",
      codeRequired: "Code is required.",
      used: "{count} / {maxCount} used",
      applied: "Discount code applied.",
      typeAbsolute: "Absolute value",
      typePercentage: "Percentage",
      affectedObjects: "Specific courses ",
      affectedPackages: "Specific packages ",
      discount: "Discount",
      type: "Discount Type",
    },
    transaction: {
      completed: "Completed",
      resendReceipt: "Resend receipt",
      refund: "Refund",
      refunded: "Refunded",
      receiptResent: "Receipt resent.",
      refundDone: "Refund done.",
      exportDone: "Data on incoming transactions was sent to your email.",
      date: "Date",
      showDetails: "Show Details",
      name: "Name",
      coursePackage: "Course/Package",
      amount: "Amount",
      new: "New",
      registered: "Registered",
      paid: "Paid",
      good: "Good",
      error: "Error",
      cancelled: "Cancelled",
    },
    export: {
      startDate: "Start date",
      endDate: "End date",
      course: "Export course students",
      statistic: "Export detailed tasks statistics",
      user: {
        withInactive: "Include already inactive users",
        withProgress: "Include course progress data",
      },
      userStats: "Export User Stats",
    },
    image: {
      upload: "Upload image",
      importFailed: "Import has failed, try again.",
      imported: "Image has been imported",
      provideImportUrl: "Please provide a url",
      confirmDelete: "Are you sure you want to remove this image?",
      delete: "Delete image",
    },
    audio: {
      upload: "Upload audio",
      importFailed: "Import has failed, try again.",
      imported: "Audio has been imported",
      confirmDelete: "Are you sure you want to remove this audio?",
      embed: "Paste a Spotify or SoundCloud link",
      download: "Download audio as: ",
    },
    text: {
      confirmDelete: "Are you sure you want to remove this text block?",
    },
    media: {
      encodingComplete: "Encoding has been completed.",
      encoding: "Encoding media",
      uploading: "Uploading media",
    },
    video: {
      upload: "Upload video",
      importFailed: "Import has failed, try again.",
      imported: "Video has been imported",
      confirmDelete: "Are you sure you want to remove this video?",
      embed: "Paste a YouTube, Vimeo or Wistia link",
      changesSaved: "Changes have been saved",
      changesCannotBeSaved: "Link is not correct",
      allowDownloading: "Allow downloading",
      download: "Download video as: ",
    },
    module: {
      confirmDelete: "Are you sure you want to remove this module?",
      removeImage: "Remove image ",
      dropOneFile: "Drop a file here ",
      dropImage: "Drop an image here ",
      dropImages: "Drop one or multiple images here ",
      youCanImport: "or paste a link ",
      or: "or ",
      orIfYouPrefer: "Or, if you prefer...",
      selectAFileFromYourComputer: "Select a file from your computer",
      dropVideo: "Drop a video here ",
      dropAudio: "Drop an audio file here ",
      uploadOrBrowse: "You can also {upload} or browse your {library} ",
      upload: "upload ",
      uploadFile: "Upload a file ",
      uploadImage: "Upload an image ",
      uploadAudio: "Upload an audio file ",
      uploadVideo: "Upload a video file ",
      library: "library ",
    },
    download: {
      upload: "Upload a file",
      confirmDelete: "Are you sure you want to remove this file?",
    },
    discussion: {
      confirmDelete: "Are you sure you want to remove this discussion?",
    },
    slideshow: {
      confirmDelete: "Are you sure you want to remove this slideshow?",
    },
    tasks: {
      noInfo: "There is no information to show",
      noTasks: "No tasks requiring your attention found",
      findCourse: "Find course",
      findGroup: "Find group",
      findStudent: "Find student",
      showCorrected: "Show corrected tasks",
      fileRemoved: "Files successfully removed",
      fileNotRemoved: "Could not remove files",
      fileUploaded: "File attached, please click SEND to send your answer.",
      students: "Students",
      courses: "Courses",
      groups: "Groups",
      corrected: "Show corrected tasks",
      correct: "Correct",
      incorrect: "Incorrect",
      defineTask: "Please define the task",
      defineQuestion: "Please define the question",
      question_description: "Describe the Question",
      emptyChoice: "Empty choice",
      addChoice: "Add choice",
      description: "Describe the task",
      submit: "Submit Answer",
      attach: "Attach File",
      answer: "Answer",
      answerOpenEnded: "Send",
      noAnswer: "No answer given",
      provideAnswer: "Please provide your answer",
      feedback: "Feedback",
      provideFeedback: "Please provide the student with some feedback",
      type: "Task Type",
      chooseType: "Choose a task type",
      answeredCount: "{answered}/{count} tasks",
      noAnsweredTasks: "No tasks",
      singleChoice: "Single Choice",
      multipleChoice: "Multiple Choice",
      text: "Text",
      openEnded: "Open-ended question",
      pleaseChooseOne: "Please make a choice",
      remove: "Remove task",
      confirmDelete: "Are you sure you want to remove this task?",
      answerSent: "Your answer has been sent to the course creator.",
      feedbackSent: "Your feedback has been sent",
      redoanswer: "Redo answer",
      showMore: "Show all results",
      showLatest: "Show latest result",
    },
    post: {
      confirmDelete: "Are you sure you want to remove this post?",
      writeAComment: "Write a comment",
      describeDiscussion: "Describe the discussion topic",
    },
    pageModule: {
      quiz: "Add question",
      quizQuestionErrorTitle: "Invalid question",
      quizQuestionErrorMessage:
        "You have a question that does not contain alternatives or correct option",
      add: "Add module",
      text: "Text",
      video: "Video",
      image: "Image",
      audio: "Audio",
      task: "Task",
      webinar: "Webinar",
      quizCommentOnQuestion: "Motivate the correct choice",
      download: "Download",
      discussion: "Discussion",
      slideshow: "Slideshow",
      created: "Module created.",
      layout: "Module layout",
      embed: "Embed",
      quiziframe: "Quiz",
    },
    card: {
      number: "Card number",
    },
    account: {
      Account: "Account",
      register:
        "To access a course you need to create a Coursio account. Please, fill in your details below: ",
      create: "Create account",
      need:
        "To buy a course you need to create a Coursio account fill in your details below:",
      have: "Have a Coursio Account?",
    },
    toc: {
      search: "Search the course",
      accept: "By registering you accept the {toc}",
      toc: "Terms and Conditions",
      close: "Close table of contents",
      open: "Open",
    },
    mediaLibrary: {
      filesRemaining: "files remaining",
      addNew: "Add New",
      Delete: "Delete",
      listView: "List View",
      thumbView: "Thumb View",
      type: "Type",
      remove: "Remove File",
      removed: "File removed.",
      uploadFiles: "Upload Files",
      removeConfirm: 'Are you sure you want to remove "{file}"?',
      removeFilesConfirm: "Are you sure you want to remove these files?",
      uploadComplete: "Upload complete.",
      dropHere: "Drop files here",
      Uploading: "Uploading...",
      Upload: "Upload",
      createDir: "Create Directory",
      directoryName: "Name of the directory",
    },
    Roles: "Roles",
    role: {
      accountant: "Accountant",
      reader: "Reader",
      editor: "Editor",
      teacher: "Teacher",
      owner: "Owner",
      darkAdmin: "Sith",
      assistant: "Assistant",
      tester: "Tester",
    },
    page: {
      addContent: "Add content",
      new: "Page",
      remove: "Remove page",
      rename: "Rename page",
      duplicate: "Duplicate page",
      confirmDelete: "Are you sure you wnat to remove this page?",
    },
    section: {
      new: "Section",
      paste: "Paste section",
      remove: "Remove section",
      confirmDelete: "Are you sure you wnat to remove this section?",
    },
    payment: {
      chooseMethod: "Choose your payment method",
      fillInDetails: "Fill in your details",
      connectToStripe: "Connect to stripe",
      payWithStripe: "Pay with stripe",
      Taxamo: "Card payment",
      Klarna: "Klarna",
      next: "Next",
      creditCard: "Card payment",
      creditCardHolder: "Credit Card Holder",
      creditCardExpirationDate: "Expiration Date",
      creditCardConfirmationCode: "CC",
      completePurchase: "Complete purchase",
      hint: {
        creditCardNumber: "XXXXXXXXXXXXXXXX",
        expYear: "YYYY",
        expMonth: "MM",
        cvc: "XXX",
      },
      validation: {
        invalidYear: "Invalid year. Needs to be in the form of YYYY (2020)",
        invalidMonth: "Invalid year. Needs to be in the form of MM (12)",
        invalidCvC: "Invalid CvC. Needs to be in the form of XXX (123)",
        invalidCreditCard: "Invalid card number, needs to be 16 chars long",
      },
      stripe: {
        number: "Credit card number",
        year: "Expiration year",
        month: "Expiration month",
        cvc: "CVC",
      },
      klarna: {
        zip: "Zip code",
        invoice: "Invoice",
        account: "Account",
        address: "Address",
        street: "Address",
        firstName: "First name",
        lastName: "Last name",
        city: "City",
        phone: "Phone",
        country: "Country",
        zipCode: "Post code",
        emailError: "Please fill in a correct email address",
        phoneError: "Please fill in a correct telephone number",
        zipCodeError: "Please fill in a correct post code",
        personalNumberError: "Please fill in a correct Swedish personal number",
        personalOrganisationalNumber: "Personal Number/ Organisation Number",
        email: "E-mail",
        next: "Next",
        personalNumberFormat: "YYYYMMDD-XXXX",
        phoneNumberFormat: "0XX XXX XXXX",
        emailFormat: "someone@coursio.com",
      },
    },
    loadMore: "Load more",
    areYouSure: "Are you sure?",
    Copy: "Copy",
    Copied: "Copied",
    OK: "OK",
    Cancel: "Cancel",
    Yes: "Yes",
    No: "No",
    Reset: "Reset",
    Sort: "Sort",
    Filter: "Filter",
    Create: "Create",
    Invite: "Invite",
    Export: "Export",
    Course: "Course",
    Courses: "Courses",
    Group: "Group",
    Time: "Time",
    Groups: "Groups",
    Email: "Email",
    Student: "Student",
    Students: "Students",
    Status: "Status",
    Search: "Search",
    Never: "Never",
    Expired: "Expired",
    selectAll: "Select All",
    deselectAll: "Deselect All",
    revokeAccess: "Revoke access?",
    noResults: "No results found",
    selectFilter: "Please make a selection",
    resultsFiltered: "Results are filtered",
    selectedCount: "{num, plural, =0{None selected} other{# selected}}",
    Next: "Next",
    addFrom: "Add From",
    Login: "Login",
    Authenticating: "Authenticating",
    Caption: "Caption",
    Other: "Other",
    importFromUrl: "Import from URL",
    Upload: "Upload",
    Import: "Import",
    Embed: "Embed",
    Reply: "Reply",
    Follow: "Follow",
    Unfollow: "Unfollow",
    Send: "Send",
    SortMessages: "Sort Messages",
    attachFile: "Attach File",
    nextPage: "Next Page",
    Modules: "Modules",
    Layout: "Layout",
    Undo: "Undo",
    Deleted: "Deleted.",
    Delete: "Delete",
    Discount: "Discount",
    Request: "Skicka",
    Buy: "Buy",
    Private: "Private",
    Public: "Public",
    TermsAndConditions: "Terms & Conditions",
    Support: "Support",
    copyright: "Copyright {year} by {name}",
    poweredBy: "Powered by {engine}",
    forgotPassword: "Forgot your password?",
    loginWithGoogle: "Login with Google",
    loginWithFacebook: "Login with Facebook",
    welcomeBack: "Welcome back, {user}!",
    useOtherLogin: "Use other login",
    VAT: "VAT",
    fullName: "Full name",
    firstname: "Firstname",
    lastname: "Lastname",
    noTasksOrNotifications: "No open tasks or new discussions",
    Branding: "Branding",
    Notifications: "Notifications",
    or: "or",
    Remove: "Remove",
    Save: "Save",
    Add: "Add",
    Clear: "Clear",
    Logout: "Logout",
    validation: {
      invalidEmail: "Enter a valid email",
      required: "This field is required",
      passwordTooShort: "Password must be at least 6 characters",
    },
    password: {
      restoreLinkMailed: "An email has been sent to you with instructions.",
      reset: "Reset password",
      newPassword: "New password",
      changed: "Your password has been changed",
      confirm: "Confirm",
      fillIn: "Fill in both fields",
    },
    storeBuilder: {
      thisIsMyStore: "This is my store",
      edit: "Edit the store layout",
      centerCenter: "Center",
      leftCenter: "Left center",
      rightCenter: "Right center",
      topLeft: "Top left",
      topCenter: "Top center",
      topRight: "Top right",
      bottomLeft: "Bottom left",
      bottomCenter: "Bottom center",
      bottomRight: "Bottom right",
      headerPosition: "Header position",
      heading: "Heading",
      list: "Store list",
      text: "Text",
      image: "Image",
      video: "Video",
      banner: "Banner",
      undo: "Undo",
      save: "Save",
      publish: "Publish",
      discard: "Discard",
    },
    gift: {
      purchaseComplete: "Purchase complete",
      explanation:
        "When buying this course as a gift, you will get a gift code sent to your email.",
      warning:
        "Please note! Enter your own email, not the email of the gift receiver.",
      nextStep:
        "A gift code has been emailed to the address you provided. You can send the link in this email to the lucky person!",
      thisCourse: "Gift this course",
      email: "Enter your Email",
      confirm: "Confirm your Email",
      emailMustMatch: "Both emails must match",
      expired:
        "This gift code has expired and thus cannot be accepted anymore.",
      used:
        "This gift code has already been used and thus cannot be accepted anymore.",
      accepted: "Gift accepted",
      help:
        "If you already used your giftcode and have access to the course log in here->app.coursio.com/login",
      acceptText: "You have been nice!",
      acceptSubText: "Enter your gift code to get access to the course",
      redirectIncoming: "You will be redirected to the dashboard.",
      redirectLoginPage: "You will be redirected to the login page.",
      needCoursioAccount:
        "To get access to courses, you need a Coursio account.",
      doesNotExist: "This gift code does not exist.",
    },
    store: {
      buyFor: "Buy for {price}",
      goto: "Go to store",
      smallCards: "Cards",
      bigCards: "Big Cards",
      list: "List",
      showOnlyMatching: "Only show courses that match these criteria:",
      bannerApproximation: "Image (approximation att Full HD)",
      bannerModule: "Banner",
      videoModule: "Video",
      textModule: "Text",
      imageModule: "Image",
      coursesModule: "Courses",
      addContent: "Add content",
      chooseVideo:
        "Please choose a video by pasting a YouTube, Vimeo or Wistia link.",
      yourCourseLeader: "Your course leader",
      joinCourse: "Join course",
      giftCourse: "Gift",
      join: "Join",
      aboutThisCourse: "About this course",
      aboutThisPack: "About this pack",
      courseContent: "Course content",
      aboutAuthor: "About {author}",
      aboutAuthorInfo: "Information about the course leader",
      courseCount: "Courses ({count})",
      overlayOpacity: "Overlay opacity",
      headerPosition: "Header position",
      header: "Header",
      image: "Image",
      filter: "Filter",
      size: "Size",
      Color: "Color",
      backgroundColor: "Background color",
      name: "Store name",
      edit: "Edit",
      takeCourse: "Join course",
      video: "Video URL",
      price: "Price",
      grossPrice: "Price (incl VAT)",
      private: "Private",
      public: "Public",
      purchaseSuccess:
        "Purchase successfully completed. You will be redirected",
      packOf: "Pack of {count}",
      noOwnerInfo: "No information about course leader yet",
      chooseCategory: "Choose category",
    },
    about: {
      support:
        'Please contact <a href="mailto:support@coursio.com">support@coursio.com</a> for technical support.',
    },
    settings: {
      SendBulletin: 'Sending bulletins',
      Bulletin: 'Bulletin',
      Webinar: 'Webinar',
      Docs: "Documents",
      termsAndConditions: "Terms & Conditions",
      courseExplanation: "What is a course?",
      support: "Support",
      aboutMe: "About me",
      storeHeadline: "Store headline",
      storeBackground: "Store background",
      readerMode: "Reader mode",
      disableScaling: "Disable scaling",
      enableScaling: "Enable scaling",
      builderMode: "Builder mode",
      displayName: "Display name",
      firstName: "First name",
      lastName: "Last name",
      language: "Language",
      email: "E-mail",
      currentPassword: "Current Password",
      addCurrentPassword: "Add Your Current Password to update E-mail",
      logo: "Logo",
      color: "Color",
      currency: "Currency",
      saved: "Settings saved.",
      avatar: "Avatar",
      Account: "Account",
      Account2: "User Settings",
      Stripe: "Stripe",
      Builder: "Builder",
      Branding: "Branding",
      ssn: "Company Registration Number",
      phone: "Phone",
      address: "Address",
      zip: "Zipcode",
      city: "City",
      country: "Country",
      Codes: "Codes",
      Notifications: "Notifications",
      gaCode: "Google Analytics Code",
      fbCode: "Facebook Pixel Code",
      gaGtm: "Google Tag Manager Code",
      checkoutCode: "Checkout code",
      ECommerce: "E-Commerce",
    },
    subAccount: {
      attention:
        "Attention! You are going to login to the user account. Be aware that anything you change will be stored permanently on the user account.",
      incarnate: "Log in",
      incarnated: "(External log in)",
    },
    Register: "Register",
    note: {
      yourNote: "Your notes...",
    },
    notification: {
      NOTIFICATION_ADDED_TO_CIRCLE: "Added to group",
      NOTIFICATION_TASK_FEEDBACK: "Feedback on task",
      NOTIFICATION_DRIP_CONTENT: "Drip content",
      NOTIFICATION_POST_ADDED: "Post added",
      NOTIFICATION_TASK_ASSESSED: "Task assessed",
      NOTIFICATION_YOU_MENTIONED: "Someone mentioned you",
      NOTIFICATION_FEEDBACK_REQUIRED: "Feedback required",
      NOTIFICATION_UNREVIEWED_TASKS: "Unreviewed tasks",
      NOTIFICATION_THREAD_NEW_POSTS: "New post in discussion",
      NOTIFICATION_COURSE_NEW_POSTS: "New post in course",
      NOTIFICATION_COURSE_SOLD: "Course sold",
      NOTIFICATION_COURSE_PACKAGE_SOLD: "Course package sold",
      NOTIFICATION_ADDED_TO_COURSE: "Added to course",
      removed: "New notifications were marked as read",
      readAll: "Mark notifications as read",
      NOTIFICATION_DATA_EXPORT: "Data export",
      NOTIFICATION_COURSE_INVITE: "Course invite",
      NOTIFICATION_BROADCAST: "Broadcast",
    },
    personalSettings: "Personal Settings",
    tag: {
      name: "Tag name",
      add: "Add tag",
    },
    emailStatus: {
      error: "Error (This usually means the mail was not sent)",
      sent: "Sent",
      bounced: "Bounced",
      rejected: "Rejected",
      unknown: "Email is unknown",
    },
    aboutCoursio:
      "Coursio is a tool for creating courses online. Read more about us at {link}.",
    Password: "Password",
    Continue: "Continue",
    Description: "Description",
    changesSaved: "Your changes have been saved.",
    exclVat: "excl. VAT",
    Edit: "Edit",
    Report: "Report",
    notFound: "404: Page not found.",
    by: "by",
    here: 'here',
    error: "An error has occurred and our team has been notified. To go back click",
    down:
      "Coursio is down at the moment and we are working on the problem. Thank you for your patience!",
    Close: "Close",
    Tags: "Tags",
    loremIpsum:
      "Hey creator! This is just a placeholder text. You should edit this text and replace it.",
  },
};



// WEBPACK FOOTER //
// ./src/js/i18n/en_US.js